import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { DataTableQueryParams } from '~/components/DataTable/DataTable'
import type {
  FilterDefinition,
  FiltersState
} from '~/components/Filters/FilterBar/types'
import { buildCompanyListSearch } from '~/domains/companies/companySearch'
import type { CompanyListItemLDResponse } from '~/domains/companies/types'

export const useCompanyList = (
  dataTableParams: DataTableQueryParams,
  barFilters: FiltersState,
  filterDefinitions?: FilterDefinition[],
  enabled = true
) => {
  const { page, itemsPerPage, sorting, columnFilters } = dataTableParams

  const { data, isLoading, isFetching, isError, refetch } = useQuery({
    queryKey: [
      'companies',
      'prospection',
      { page, itemsPerPage, sorting, columnFilters, barFilters }
    ],
    queryFn: () =>
      fetchApiWithToken<CompanyListItemLDResponse>({
        method: 'get',
        url: `/v1/companies/prospection?${buildCompanyListSearch(dataTableParams, barFilters, filterDefinitions)}`,
        useLDJson: true
      }),
    enabled,
    staleTime: 60_000,
    placeholderData: keepPreviousData
  })

  return {
    data: data?.['hydra:member'] ?? [],
    totalItems: data?.['hydra:totalItems'] ?? 0,
    isLoading,
    isFetching,
    isError,
    refetch
  }
}
